// Saved replies and categories can only be changed by the coach who owns them (api #96).
// Shared ones (made by the admin team) and other coaches' ones are read-only.
export const isOwnedByCurrentCoach = (dataObject) => dataObject?.owned_by_current_coach === true;
